import React, { useContext, useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router";
import { LogOut, Star, Settings, KeyRound } from "lucide-react";
import useAuthActions from "../hooks/useAuthActions";
import { AuthContext, superUserUID } from "../helpers/Auth";

const UserMenu = ({ trigger }: { trigger: any }) => {
  const { signOut } = useAuthActions();
  const navigate = useNavigate();
  const { currentUser } = useContext(AuthContext)!;
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e: any) => {
      if (menuRef.current && !(menuRef.current as any).contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block" ref={menuRef}>
      <button type="button" onClick={() => setOpen(!open)} className="cursor-pointer">
        {trigger}
      </button>
      {open && (
        <div className="absolute right-0 z-50 mt-1 w-56 rounded-md border bg-popover text-popover-foreground shadow-lg">
          <div className="px-3 py-2 text-xs font-semibold text-muted-foreground uppercase">Commands</div>
          <button
            className="flex w-full items-center gap-2 px-3 py-2 text-sm hover:bg-accent transition-colors"
            onClick={() => { signOut(); setOpen(false); }}
          >
            <LogOut className="h-4 w-4" /> Logout
          </button>
          <button
            className="flex w-full items-center gap-2 px-3 py-2 text-sm hover:bg-accent transition-colors"
            onClick={() => { navigate("/favourite_firings"); setOpen(false); }}
          >
            <Star className="h-4 w-4" /> My Favourite Firings
          </button>
          <button
            className="flex w-full items-center gap-2 px-3 py-2 text-sm hover:bg-accent transition-colors"
            onClick={() => { navigate("/preferences"); setOpen(false); }}
          >
            <Settings className="h-4 w-4" /> User Preferences
          </button>
          <button
            className="flex w-full items-center gap-2 px-3 py-2 text-sm hover:bg-accent transition-colors"
            onClick={() => { navigate("/change-password"); setOpen(false); }}
          >
            <KeyRound className="h-4 w-4" /> Change Password
          </button>
          {currentUser && currentUser.uid === superUserUID && (
            <>
              <div className="my-1 border-t" />
              <button
                className="flex w-full items-center gap-2 px-3 py-2 text-sm hover:bg-accent transition-colors"
                onClick={() => { navigate("/superuser"); setOpen(false); }}
              >
                <Settings className="h-4 w-4" /> SuperUser Functions
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default UserMenu;
